/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationCrossPlayHandlersEventRuleDTO
 */
export interface FxIdApplicationCrossPlayHandlersEventRuleDTO {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationCrossPlayHandlersEventRuleDTO
     */
    Game: string;
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationCrossPlayHandlersEventRuleDTO
     */
    EventId: number;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationCrossPlayHandlersEventRuleDTO
     */
    Code: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationCrossPlayHandlersEventRuleDTO
     */
    Filter1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationCrossPlayHandlersEventRuleDTO
     */
    Filter2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationCrossPlayHandlersEventRuleDTO
     */
    Filter3?: string | null;
}

/**
 * Check if a given object implements the FxIdApplicationCrossPlayHandlersEventRuleDTO interface.
 */
export function instanceOfFxIdApplicationCrossPlayHandlersEventRuleDTO(value: object): value is FxIdApplicationCrossPlayHandlersEventRuleDTO {
    if (!('Game' in value) || value['Game'] === undefined) return false;
    if (!('EventId' in value) || value['EventId'] === undefined) return false;
    if (!('Code' in value) || value['Code'] === undefined) return false;
    return true;
}

export function FxIdApplicationCrossPlayHandlersEventRuleDTOFromJSON(json: any): FxIdApplicationCrossPlayHandlersEventRuleDTO {
    return FxIdApplicationCrossPlayHandlersEventRuleDTOFromJSONTyped(json, false);
}

export function FxIdApplicationCrossPlayHandlersEventRuleDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationCrossPlayHandlersEventRuleDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'Game': json['Game'],
        'EventId': json['EventId'],
        'Code': json['Code'],
        'Filter1': json['Filter1'] == null ? undefined : json['Filter1'],
        'Filter2': json['Filter2'] == null ? undefined : json['Filter2'],
        'Filter3': json['Filter3'] == null ? undefined : json['Filter3'],
    };
}

export function FxIdApplicationCrossPlayHandlersEventRuleDTOToJSON(json: any): FxIdApplicationCrossPlayHandlersEventRuleDTO {
    return FxIdApplicationCrossPlayHandlersEventRuleDTOToJSONTyped(json, false);
}

export function FxIdApplicationCrossPlayHandlersEventRuleDTOToJSONTyped(value?: FxIdApplicationCrossPlayHandlersEventRuleDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Game': value['Game'],
        'EventId': value['EventId'],
        'Code': value['Code'],
        'Filter1': value['Filter1'],
        'Filter2': value['Filter2'],
        'Filter3': value['Filter3'],
    };
}

